"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// NOTE: Type TargetWindow is an auto-generated type.
// Run node ./tools/generateTargetWindow.js to generate it.
/**
 * Try get window from the given node or range
 * @param source Source node or range
 */
function getTargetWindow(source) {
    var node = source && (source.commonAncestorContainer || source);
    var document = node &&
        (node.ownerDocument ||
            (Object.prototype.toString.apply(node) == '[object HTMLDocument]'
                ? node
                : null));
    // If document exists but document.defaultView doesn't exist, it is a detached object, just use current window instead
    var targetWindow = document && (document.defaultView || window);
    return targetWindow;
}
exports.getTargetWindow = getTargetWindow;
/**
 * Check if the given object is instance of the target type
 * @param obj Object to check
 * @param typeName Target type name
 */
function safeInstanceOf(obj, typeName) {
    var targetWindow = getTargetWindow(obj);
    var targetType = targetWindow && targetWindow[typeName];
    var mainWindow = window;
    var mainWindowType = mainWindow && mainWindow[typeName];
    return ((mainWindowType && obj instanceof mainWindowType) ||
        (targetType && obj instanceof targetType));
}
exports.default = safeInstanceOf;
//# sourceMappingURL=safeInstanceOf.js.map